/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "368")
  

// 接口文档

  
    
export interface IAPI73950ResFromObj {
  
  /**  */
  userType?: string;
  
  /**  */
  headImg?: string;
  
  /**  */
  nickName?: string;
  
  /**  */
  realName?: string;
  
};
    
  
    
export interface IAPI73950ResToObj {
  
  /**  */
  userType?: string;
  
  /**  */
  headImg?: string;
  
  /**  */
  nickName?: string;
  
  /**  */
  realName?: string;
  
};
    
  
    
export interface IAPI73950ResRecordsItemActionsItem {
  
  /**  */
  label?: string;
  
  /**  */
  value?: string;
  
  /**  */
  isSelect?: boolean;
  
};
    
  
    
export interface IAPI73950ResRecordsItem {
  
  /**  */
  id?: number;
  
  /**  */
  sessionToken?: string;
  
  /**  */
  sendTime?: string;
  
  /**  */
  content?: string;
  
  /**  */
  source?: string;
  
  /** ActionResult */
  actions?: IAPI73950ResRecordsItemActionsItem[];
  
};
    
  



export interface API73950Req {
  
  /** 评估结果 */
  evaluateResult?: string;
};



export interface API73950Res {
  /**   */
  sessionToken?: string;
  /** ChatUserResult  */
  from?: IAPI73950ResFromObj;
  /** ChatUserResult  */
  to?: IAPI73950ResToObj;
  /**   */
  params?: string;
  /** ChatRecordResult  */
  records?: IAPI73950ResRecordsItem[];
  
};


// 接口函数 73950 评估任务分发

export interface IUsePostAPI73950Return {
  /** 评估任务分发: 接口请求状态 */
  isAPI73950Loading: boolean;
  /** 评估任务分发: 接口请求返回数据 */
  dataAPI73950: API73950Res;
  /**  评估任务分发: 接口数据请求方法 */
  fetchAPI73950Data: (inputs: API73950Req, config?: YWRequestConfig) => Promise<API73950Res>;
  /** 评估任务分发: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI73950 = ():IUsePostAPI73950Return => {
  let isMount = true;
  const [isAPI73950Loading, setIsAPI73950Loading] = useState(false);
  const [dataAPI73950, setDataAPI73950] = useState<API73950Res>({} as API73950Res);
  const requestUrl = `${basePath}/internal-control-biz/admin/anchor/ai/evaluation/task/distribute`;

  const fetchAPI73950Data = async (inputs: API73950Req, config?: YWRequestConfig): Promise<API73950Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API73950Req>) || {}) as API73950Req;
    
  
    if ( isMount ) {
      setIsAPI73950Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API73950Res>(`${basePath}/internal-control-biz/admin/anchor/ai/evaluation/task/distribute`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI73950(res || {} as API73950Res);
        setIsAPI73950Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI73950Loading(false);
      }
      return false as unknown as API73950Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI73950Loading,
    dataAPI73950,
    fetchAPI73950Data,
    requestUrl,
  }
}

